const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuariIdActivitatsIdPdf = async (id_activitat : string, id_usuari: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id_usuari}/activitats/${id_activitat}/pdf`);

        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
